<nb-card style="min-width: 560px; max-width: 720px">
  <nb-card-header>
    <strong>{{ isEditMode ? 'Edit SSO Application' : 'Create New SSO Application' }}</strong>
  </nb-card-header>
  <nb-card-body>
    <form [formGroup]="appForm">
      <div class="row">
        <div class="col-12" style="margin-bottom: 16px">
          <label class="form-label">Name <span class="text-danger">*</span></label>
          <input
            nbInput
            fullWidth
            class="form-control"
            placeholder="Application name"
            formControlName="name"
          />
        </div>

        <div class="col-12" style="margin-bottom: 16px">
          <label class="form-label">Description</label>
          <textarea
            nbInput
            fullWidth
            class="form-control"
            placeholder="Optional description"
            formControlName="description"
            rows="2"
          ></textarea>
        </div>

        <div class="col-12" style="margin-bottom: 16px">
          <label class="form-label">Redirect URIs <span class="text-danger">*</span></label>
          <div *ngFor="let uri of redirectUris; let i = index" class="uri-row">
            <input
              nbInput
              fullWidth
              class="form-control"
              placeholder="https://example.com/callback"
              [(ngModel)]="redirectUris[i]"
              [ngModelOptions]="{ standalone: true }"
            />
            <button
              type="button"
              class="btn btn-sm btn-outline-danger uri-btn"
              (click)="removeRedirectUri(i)"
              [disabled]="redirectUris.length === 1"
              nbTooltip="Remove URI"
            >
              <nb-icon icon="trash-2-outline"></nb-icon>
            </button>
          </div>
          <button type="button" class="btn btn-sm btn-outline-primary mt-2" (click)="addRedirectUri()">
            + Add Redirect URI
          </button>
        </div>

        <div class="col-12" style="margin-bottom: 16px">
          <label class="form-label">Post-Logout Redirect URIs</label>
          <div *ngFor="let uri of postLogoutRedirectUris; let i = index" class="uri-row">
            <input
              nbInput
              fullWidth
              class="form-control"
              placeholder="https://example.com/logout"
              [(ngModel)]="postLogoutRedirectUris[i]"
              [ngModelOptions]="{ standalone: true }"
            />
            <button
              type="button"
              class="btn btn-sm btn-outline-danger uri-btn"
              (click)="removePostLogoutUri(i)"
              nbTooltip="Remove URI"
            >
              <nb-icon icon="trash-2-outline"></nb-icon>
            </button>
          </div>
          <button type="button" class="btn btn-sm btn-outline-primary mt-2" (click)="addPostLogoutUri()">
            + Add Post-Logout URI
          </button>
        </div>

        <div class="col-12" style="margin-bottom: 16px">
          <label class="form-label">Allowed Roles <span class="text-danger">*</span></label>
          <div class="checkbox-grid">
            <div *ngFor="let role of availableRoles" class="checkbox-item">
              <nb-checkbox
                [checked]="isRoleSelected(role)"
                (checkedChange)="toggleRole(role)"
              >
                {{ role }}
              </nb-checkbox>
            </div>
          </div>
        </div>

        <div class="col-12">
          <label class="form-label">Scopes</label>
          <div class="checkbox-grid">
            <div *ngFor="let scope of availableScopes" class="checkbox-item">
              <nb-checkbox
                [checked]="isScopeSelected(scope)"
                [disabled]="isScopeLocked(scope)"
                (checkedChange)="toggleScope(scope)"
              >
                {{ scope }}
                <small *ngIf="isScopeLocked(scope)" class="text-muted"> (required)</small>
              </nb-checkbox>
            </div>
          </div>
        </div>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer>
    <div style="display: flex; justify-content: flex-end; gap: 10px">
      <button type="button" class="btn btn-secondary px-4" (click)="onCancel()">Cancel</button>
      <button type="button" class="btn btn-primary px-4" (click)="onSubmit()">
        {{ isEditMode ? 'Save Changes' : 'Create Application' }}
      </button>
    </div>
  </nb-card-footer>
</nb-card>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus">
  <p style="color: white">{{ isEditMode ? 'Saving...' : 'Creating...' }}</p>
</ngx-spinner>
